var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('img',{attrs:{"src":"https://cdn.vip-wifi.com/fangchan/config/pages/packageA/loan_computer/computer-help.png"}}),_c('page-wrap',{attrs:{"title":"帮助"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }